import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

// Import the main website component
const MainWebsite = React.lazy(() => import('./App').then(module => ({ default: module.MainWebsite })));

const VideoLandingPage = ({ videoId }) => {
  const [searchParams] = useSearchParams();
  const [currentVideo, setCurrentVideo] = useState(null);

  // Video data array matching the main website
  const videos = [
    {
      id: 1,
      title: "The £56 Billion Problem",
      description: "Discover the staggering annual cost of poor workplace wellbeing across the UK and why it matters to your business.",
      duration: "90 seconds • Introduction",
      videoUrl: "https://customer-assets.emergentagent.com/job_workplace-balance/artifacts/2z54np5o_%C2%A356%20Billion.mp4",
      number: "1/7"
    },
    {
      id: 2,
      title: "Sickness Absence Costs",
      description: "Break down the real costs of sickness absence and understand how they impact your bottom line.",
      duration: "90 seconds • Cost Analysis",
      videoUrl: "https://customer-assets.emergentagent.com/job_workplace-balance/artifacts/8c69w0b8_Sickness%20Absence.mp4",
      number: "2/7"
    },
    {
      id: 3,
      title: "Recruitment Costs",
      description: "Uncover the hidden costs of high staff turnover and constant recruitment in your organisation.",
      duration: "90 seconds • Cost Analysis",
      videoUrl: "https://customer-assets.emergentagent.com/job_workplace-balance/artifacts/kckrz7wh_Recruitment%20costs.mp4",
      number: "3/7"
    },
    {
      id: 4,
      title: "Presenteeism & Productivity",
      description: "Learn about the costly impact of employees who are physically present but mentally absent.",
      duration: "90 seconds • Cost Analysis",
      videoUrl: "https://customer-assets.emergentagent.com/job_workplace-balance/artifacts/y50fvqh9_Presenteeism.mp4",
      number: "4/7"
    },
    {
      id: 5,
      title: "Leading Causes of Absence",
      description: "Discover the top reasons employees take sick leave and what this means for your business.",
      duration: "90 seconds • Research Insights",
      videoUrl: "https://customer-assets.emergentagent.com/job_workplace-balance/artifacts/rhetwkrv_CIPD%20report.mp4",
      number: "5/7"
    },
    {
      id: 6,
      title: "Culture & Behaviours",
      description: "How positive workplace culture and behaviours can support employee wellbeing and reduce costs.",
      duration: "90 seconds • Solutions",
      videoUrl: "https://customer-assets.emergentagent.com/job_wellbeing-hub-42/artifacts/ocuo707s_Culture%20and%20Behaviours.mp4",
      number: "6/7"
    },
    {
      id: 7,
      title: "Calculate Your Costs",
      description: "Step-by-step guide to working out your specific workplace wellbeing costs.",
      duration: "90 seconds • Calculation",
      videoUrl: "https://customer-assets.emergentagent.com/job_wellbeing-hub-42/artifacts/qu6qk4ms_Workplace%20wellbeing%20costs.mp4",
      number: "7/7"
    }
  ];

  useEffect(() => {
    // Capture UTM parameters for analytics
    const utmParams = {
      utm_source: searchParams.get('utm_source'),
      utm_medium: searchParams.get('utm_medium'),
      utm_campaign: searchParams.get('utm_campaign'),
      utm_term: searchParams.get('utm_term'),
      utm_content: searchParams.get('utm_content')
    };

    // Log UTM parameters (you can send these to your analytics service)
    if (utmParams.utm_source) {
      console.log('UTM Tracking:', utmParams);
      
      // Store in sessionStorage for potential analytics integration
      sessionStorage.setItem('utm_params', JSON.stringify(utmParams));
      
      // You can also send to Google Analytics or your analytics service here:
      // Example: gtag('event', 'video_landing', { ...utmParams, video_id: videoId });
    }

    // Auto-open the video modal after a short delay
    const timer = setTimeout(() => {
      const video = videos.find(v => v.id === parseInt(videoId));
      if (video) {
        setCurrentVideo(video);
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [videoId, searchParams]);

  // Scroll to video section when modal closes
  const handleCloseVideo = () => {
    setCurrentVideo(null);
    // Scroll to the masterclass section
    setTimeout(() => {
      const element = document.getElementById('wellbeing-masterclass');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <>
      <React.Suspense fallback={
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <div className="w-16 h-16 border-4 border-golden border-t-carbon rounded-full animate-spin mx-auto mb-4"></div>
            <p className="text-carbon font-semibold">Loading video...</p>
          </div>
        </div>
      }>
        <MainWebsite initialVideo={currentVideo} onVideoClose={handleCloseVideo} />
      </React.Suspense>
    </>
  );
};

export default VideoLandingPage;
